import { useRedirect } from "src/navigation/useRedirect";
import styles from "src/components/molecules/MenuBottomBar/styles.module.css";
import { MODALS, PAGES } from "src/types/navigation";
import { HomeIcon } from "src/components/atoms/HomeIcon";
import { Msg } from "src/i18n/Msg";
import { FavoriteIcon } from "src/components/atoms/FavoriteIcon";
import { BarIcon } from "src/components/atoms/BarIcon";
import React from "react";
import { useLocation } from "react-router-dom";
import cx from "classnames";
import { RootState } from "src/store";
import { useSelector } from "react-redux";
import { useTheme } from "src/context/ThemeContext";
import { hasTelegramWebApp, isTelegramWebApp } from "src/utils/telegramWebApp";

type Props = {
  handleCollapseMenu?: () => void;
};

export const MenuBottomBar: React.FC<Props> = ({ handleCollapseMenu }) => {
  const { redirect, openModal } = useRedirect();
  const { pathname } = useLocation();
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  const params = new URLSearchParams(window.location.search);
  const isTgVersion =
    params.get("tg") === "1" || isTelegramWebApp() || hasTelegramWebApp();
  const user = useSelector((state: RootState) => state.profile.user);
  const isLoggined = user?.id;
  const handleClick = (scheme: PAGES) => redirect({ scheme });
  const isActiveRoute = (route: string) => pathname === route;

  const getIconColor = (isActive: boolean) => {
    if (isDark) {
      return isActive ? "#E4E4E4" : "#828282";
    }
    return isActive ? "#262627" : "#828282";
  };

  const handleClickMenu = () =>
    isLoggined ? handleCollapseMenu?.() : openModal({ scheme: MODALS.SIGN_IN });

  return (
    <div
      className={cx(styles.menu, {
        [styles.tgSafeArea]: isTgVersion,
      })}
    >
      <div
        role="button"
        onClick={() => handleClick(PAGES.ROOT)}
        className={cx(styles.menuItem, {
          [styles.activeMenu]: isActiveRoute(PAGES.ROOT),
        })}
      >
        <HomeIcon fill={getIconColor(isActiveRoute(PAGES.ROOT))} />
        <p>
          <Msg id="components.molecules.MenuBottomBar.home" />
        </p>
      </div>
      <div
        onClick={() => {
          if (isLoggined) {
            handleClick(PAGES.FAVORITES);
          } else {
            openModal({ scheme: MODALS.SIGN_IN });
          }
        }}
        role="button"
        className={cx(styles.menuItem, {
          [styles.activeMenu]: isActiveRoute(PAGES.FAVORITES),
        })}
      >
        <FavoriteIcon
          fill={getIconColor(isActiveRoute(PAGES.FAVORITES))}
        />
        <p>
          <Msg id="components.molecules.MenuBottomBar.favorite" />
        </p>
      </div>
      <div
        onClick={handleClickMenu}
        role="butoon"
        className={cx(styles.menuItem)}
      >
        <BarIcon />
        <p>
          <Msg id="components.molecules.MenuBottomBar.menu" />
        </p>
      </div>
    </div>
  );
};
